import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2max.teaser');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setEnter(true);
        }, 500);

        // const scroll = () => {
        //     const header = document.querySelector('.ecoflow-header') as HTMLDivElement;
        //     const target = document.querySelector('.d2x-teaser-A .sec1 .top-note') as HTMLDivElement;
        //     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //     const topY = header?.offsetHeight >= scrollTop ? header?.offsetHeight - scrollTop : 0;
        //     target.style.transition = 'none';
        //     target.style.top = `${topY}px`;
        // };
        // document.addEventListener('scroll', scroll);
        return () => {
            // document.removeEventListener('scroll', scroll);
            clearTimeout(timer);
        };
    }, []);

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.d2x-teaser-A .text-ani', { y: 0 }, { y: -200 }]],
            triggerElement: '.d2x-teaser-A .img-box',
            triggerHook: 0,
            // offset: 60,
            duration: 1080,
        });
    }, []);

    return (
        <div className={`d2x-teaser-A ${css.d2xTeaserA}`}>
            <div className={`sec1 ${enter ? 'enter' : ''}`}>
                <div className="top-note">
                    <p className="note">{t('sec1_note')}</p>
                </div>
                <div className="img-box">
                    <NextImage
                        webpSrc={require(`@publicLocal/delta2max/teaser/pc/${locale === 'za' ? locale : 'us'}/1.jpg`)}
                        src={require(`@publicLocal/delta2max/teaser/pc/${locale === 'za' ? locale : 'us'}/1.jpg`)}
                        alt={t('sec1_desc')}
                        aria-label={t('sec1_desc')}
                    />
                </div>
                <div className="text-box">
                    <div className="text-ani">
                        {locale === 'za' && <p className="date">{t('sec1_date')}</p>}
                        <div className="title">
                            {t.rich('sec1_title', {
                                green: (text: string) => <span className="green-line">{text}</span>,
                            })}
                        </div>
                        <p className="desc">{t('sec1_desc')}</p>
                        {locale !== 'za' && <p className="date">{t('sec1_date')}</p>}
                    </div>
                </div>
                <div className="red-dot">
                    <div className="dot-icon">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/reddot.png')}
                            src={require('@publicLocal/delta2max/reddot.png')}
                            alt={t('sec1_desc')}
                            aria-label={t('sec1_desc')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
